type PrefetchedResponse = {
	ok: boolean;
	status: number | null;
	statusText: string | null;
	arrayBuffer: ArrayBuffer | null;
};
const promiseLookup: Record<string, Promise<PrefetchedResponse>> = {};

export const clearFetchCache = () => {
	Object.keys(promiseLookup).forEach((key) => {
		delete promiseLookup[key];
	});
};

const defaultRetryStatusCodes = new Set([500, 502, 503]);
const fetchWithRetry = async (
	url: string,
	{
		retryStatusCodes = defaultRetryStatusCodes,
	}: {
		retryStatusCodes?: Set<number>;
	} = {},
): Promise<PrefetchedResponse> => {
	let numAttempts = 0;
	let res: Response | null = null;
	while (numAttempts < 10) {
		res = await fetch(url).catch(() => null);
		if (res?.ok)
			return {
				ok: true,
				status: res.status,
				statusText: res.statusText,
				arrayBuffer: await res.arrayBuffer(),
			};
		if (res && !retryStatusCodes.has(res.status)) {
			throw new Error(`Failed to fetch image: ${res.status} ${res.statusText}`);
		}
		await new Promise((resolve) => setTimeout(resolve, 50));
	}
	return {
		ok: false,
		status: res?.status ?? null,
		statusText: res?.statusText ?? null,
		arrayBuffer: null,
	};
};
const cachedFetchWithRetry = async (
	url: string,
	options?: {
		retryStatusCodes?: Set<number>;
	},
): Promise<PrefetchedResponse> => {
	if (!promiseLookup[url]) {
		promiseLookup[url] = fetchWithRetry(url, options);
	}
	const res = await promiseLookup[url];
	if (!res.ok) {
		delete promiseLookup[url];
	}
	return res;
};
export default cachedFetchWithRetry;
